import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '../../../tool'
import {WizTaskSet,WizFeaturedSet,WizNoticeSet} from '../../common'

const { WizContainer, modelUtils } = framework_tool;
const {WizTabs} = component_tool

class HighSetDemo extends WizContainer {

  componentName = 'highSetDemo';

  constructor(props){
    super(props);
    this.state = {
      record:[],
      bizType: 15
    }
  }

  _componentDidMount(){
    this.doActions([
      {
        path: 'noticeTemplate/noticeInfoList',
        payload: {
          key: 'noticeTemplate@noticeList',
          apiParams: {
            businessId: 38,
            bizType: 38
          }
        }
      },
      {
        path: 'noticeTemplate/noticeInfoList',
        payload: {
          key: 'noticeTemplate@messageList',
          apiParams: {
            businessId: 38,
            bizType: 15
          }
        }
      },
    ])
  }

  render() {
    let {messageData, messageList} = this.props
    return (
      <div style={{backgroundColor:'#FFF',width: '900px',margin: "auto"}} >
        <WizTabs defaultActiveKey='1' onChange={this.changeTab}>
          <WizTabs.TabPane tab={'任务设置'} key='1'>
            <WizTaskSet record={this.state.record} taskNoticeData={messageData.data}/>
          </WizTabs.TabPane>
          <WizTabs.TabPane tab={'推荐设置'} key='2'>
            <WizFeaturedSet record={this.state.record} />
          </WizTabs.TabPane>
          <WizTabs.TabPane tab={'消息通知设置'} key='3'>
            <WizNoticeSet record={messageList.data}/>
          </WizTabs.TabPane>
        </WizTabs>
      </div>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  const {noticeTemplate} = state;

  const messageData = modelUtils.getModelEntity(noticeTemplate, 'noticeTemplate@noticeList')
  const messageList = modelUtils.getModelEntity(noticeTemplate, 'noticeTemplate@messageList')
  return {
    messageData,
    messageList
  };
};

export default connect(mapStateToProps)(HighSetDemo);
